export enum DialogButtonTypesEnum {
    Cancel,
    Remove,
    Delete,
    Ok,
    Submit,
    Confirm,
    Create,
    Apply,
    Save,
    Update
}
